module.exports = __webpack_public_path__ + "static/media/uses-standard-medical-protocol@3x.c3716519.png";